import type { OrderItem } from '@octave/contracts';
import { AccessoryItemMetadata } from './AccessoryItemMetadata';
import { DeviceItemMetadata } from './DeviceItemMetadata';
import { FeeItemMetadata } from './FeeItemMetadata';
import { LineItemMetadata } from './LineItemMetadata';
import { SimItemMetadata } from './SimItemMetadata';
import { TravelEsimItemMetadata } from './TravelEsimItemMetadata';

interface OrderItemMetadataProps {
  item: OrderItem;
  /** Lets a travel eSIM line open its QR code. */
  orderId?: string;
  /** Octave admin view: a travel eSIM QR can be previewed before it is sent, and the plans to buy are listed. */
  canPreviewUnsent?: boolean;
}

export function OrderItemMetadata({
  item,
  orderId,
  canPreviewUnsent,
}: OrderItemMetadataProps) {
  if (item.type === 'SIM' || item.type === 'ESIM') {
    return <SimItemMetadata item={item} />;
  }

  if (item.type === 'DEVICE') {
    return <DeviceItemMetadata item={item} />;
  }

  if (item.type === 'ACCESSORY') {
    return <AccessoryItemMetadata item={item} />;
  }

  if (item.type === 'FEES') {
    return <FeeItemMetadata item={item} />;
  }

  if (item.type === 'TRAVEL_ESIM') {
    return (
      <TravelEsimItemMetadata
        item={item}
        orderId={orderId}
        canPreviewUnsent={canPreviewUnsent}
        showComponents={canPreviewUnsent}
      />
    );
  }

  return <LineItemMetadata item={item} />;
}
